/** Kalendar widgeti sozlamasi. Backend tekshiruvi bilan bir xil (apps/widgets/registry.py, clean_calendar). */
import type { Me } from "@/features/auth/types";

export const CALENDAR_KINDS = ["reminder", "start", "fee", "expiry", "available", "assignment"] as const;
export type CalendarKind = (typeof CALENDAR_KINDS)[number];

export interface CalendarConfig {
  /** Ko'rsatiladigan voqea turlari (kamida bittasi) */
  kinds: CalendarKind[];
  /** Bajarilgan eslatmalar ham ko'rinsinmi */
  done: boolean;
}

export function defaultCalendarConfig(_me: Pick<Me, "role">): CalendarConfig {
  return { kinds: [...CALENDAR_KINDS], done: false };
}

export function parseCalendarConfig(raw: unknown, me: Pick<Me, "role">): CalendarConfig {
  const fallback = defaultCalendarConfig(me);
  if (!raw || typeof raw !== "object") return fallback;
  const r = raw as Record<string, unknown>;
  const kinds = Array.isArray(r.kinds) ? CALENDAR_KINDS.filter((k) => (r.kinds as unknown[]).includes(k)) : [];
  return { kinds: kinds.length ? kinds : fallback.kinds, done: typeof r.done === "boolean" ? r.done : fallback.done };
}
